export default __webpack_public_path__ + "static/media/checked.fe830df3.svg";